import * as React from 'react';
import TractDetailData from 'src/models/tract_detail/TractDetail';
import * as _ from 'lodash';
import SearchResult from 'src/models/OwnerSearchResult';
import AddOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddOwnership';
import './OwnerSearch.scss';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';
import IOwner from 'src/models/IOwner';
import PhoneNumberType from 'src/models/PhoneNumberType';
import USPSCityState from 'src/models/USPSCityState';
import AddOwner from 'src/models/tract_detail/add_ownership_revised/AddOwner';
import AddWIOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddWIOwnership';
import Dialog from 'src/components/common/Dialog.redesign';
import NewOwnerForm from './NewOwnershipForm';
import ExistingOwnerForm from './ExistingOwnerForm';
import { useContext, useEffect, useState } from 'react';
import { AnyObject } from 'react-final-form';
import AddOwnershipPages from './AddOwnershipPages';
import OwnerType from './OwnerType';
import { FormErrors } from 'src/util/FormErrors';
import { FormApi } from 'final-form';
import { useFetch } from 'use-http';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import { ODataFilter, ODataFilterOperators, ODataOptions, ODataOrderByDirection } from 'src/util/ODataBuilder';
import OwnershipFormUtil from './OwnershipFormUtil';
import LeaseGenerationTractDetail from 'src/models/leasing/LeaseGenerationTractDetail';
import { ITableConfig } from 'src/components/common/table';

interface IAddMineralOwnershipProps {
    dialogType: string;
    title: string;
    tract?: TractDetailData;
    horizon?: number;
    parentOwnershipId?: number;
    navigate: (path: string) => void;
    saveAddTractOwnership?: (values: AddOwnershipData) => void;
    saveAddLeaseOwnership?: (values: AddWIOwnershipData) => void;
    addDeviation: (values: AddOwner, containerOwnerId: number, ownerType: string) => void;
    onCloseDialog?: () => void;
}

const AddMineralOwnership: React.FC<IAddMineralOwnershipProps> = (props) => {
    // TODO: Set up an endpoint to grab these.
    const ownerTypes = [
        { id: OwnerType.Individual, name: 'Individual' },
        { id: OwnerType.Trust, name: 'Trust' },
        { id: OwnerType.Business, name: 'Business' },
        { id: OwnerType.GovBLM, name: 'Gov-BLM' },
        { id: OwnerType.GovRAL, name: 'Gov-RAL' },
        { id: OwnerType.GovSTATE, name: 'Gov-STATE' },
        { id: OwnerType.JointTenant, name: 'Joint Tenant' },
    ];

    const ownershipType = ['FEE', '0', '1'];

    const { get, response } = useFetch();
    const appContext = useContext<IAppContextState>(AppContext);

    const [page, setPage] = useState<AddOwnershipPages>(AddOwnershipPages.AddOwnershipLandingPage);
    const [states, setStates] = useState<PagedResultSet<State>>(undefined);
    const [phoneNumberTypes, setPhoneNumberTypes] = useState<PhoneNumberType[]>([]);
    const [uspsCityState, setUspsCityState] = useState<USPSCityState>(undefined);
    const [searchResults, setSearchResults] = useState<PagedResultSet<SearchResult>>(new PagedResultSet());
    const [ownerTracts, setOwnerTracts] = useState<Array<LeaseGenerationTractDetail>>([]);
    const [ownerDetails, setOwnerDetails] = useState<Array<IOwner>>([]);
    const [currentOwnerType, setCurrentOwnerType] = useState<string>(undefined);
    const [ownerSearchDataOptions, setOwnerSearchDataOptions] = useState<ODataOptions>(undefined);
    const [newOwnerForm, setNewOwnerForm] = useState<FormApi>(undefined);
    const [existingOwnerForm, setExistingOwnerForm] = useState<FormApi>(undefined);
    const [fetchNextPage, setFetchNextPage] = useState<boolean>(true);

    useEffect(() => {
        setNewOwnerForm(undefined);
        setExistingOwnerForm(undefined);
        getStates(new ODataOptions().addPaging(1, 100));
        getPhoneNumberTypes();
        initializeOwnerSearchDataOptions();
    }, []);

    useEffect(() => {
        if (!!ownerSearchDataOptions) {
            searchPagedOwners();
        }
    }, [ownerSearchDataOptions]);

    useEffect(() => {
        if (page === AddOwnershipPages.NewOwnerInfoForm && !!uspsCityState && !!currentOwnerType) {
            OwnershipFormUtil.alterCityState(states.items, uspsCityState, newOwnerForm, currentOwnerType);
        } else if (page === AddOwnershipPages.NewDeviationInfoForm && !!uspsCityState && !!currentOwnerType) {
            OwnershipFormUtil.alterCityState(states.items, uspsCityState, existingOwnerForm);
        }
    }, [page, uspsCityState, currentOwnerType]);

    const initializeFormAndState = () => {
        setSearchResults(undefined);
        setOwnerTracts(undefined);
        setPage(AddOwnershipPages.AddOwnershipLandingPage);
    };

    const initializeOwnerSearchDataOptions = () => {
        const tableConfig: ITableConfig = {
            rowCount: 25,
            idField: 'Id',
            pageNumber: 1,
            columns: []
        };
        setOwnerSearchDataOptions(ODataOptions.from(tableConfig).addOrderBy('Name', ODataOrderByDirection.Ascending));
    };

    const getStates = async (options: ODataOptions) => {
        const result = await get(`v1.0/states/${options.toString()}`);

        if (response.ok) {
            setStates(result);
        }
    };

    const getPhoneNumberTypes = async () => {
        const result = await get(`v1.0/phoneNumberTypes`);

        if (response.ok) {
            setPhoneNumberTypes(result);
        }
    };

    const getCityState = async (zipCode: string, ownerType?: string, form?: FormApi) => {
        const result = await get(`v1.0/usps/${zipCode}/local-source`);

        if (!!ownerType && !!form) {
            setCurrentOwnerType(ownerType);
            setNewOwnerForm(form);
        }

        if (response.ok) {
            setUspsCityState(result);
        }
    };

/*     const searchOwners = async (searchText: string, ownerType: string) => {
        const result = await get(
            `v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/owner-search/${searchText}/${ownerType}`
        );

        if (response.ok) {
            setSearchResults(result);
        }
    }; */

    const getScrollStatus = (divElement: HTMLDivElement) => {
        if (divElement) {
            const scrollTop = divElement.scrollTop % 1 > .9 ? divElement.scrollTop : Math.round(divElement.scrollTop);
            const scrollHeight = divElement.scrollHeight;
            const clientHeight = divElement.clientHeight;

            // Check if reached the end of the list
            if (scrollTop + clientHeight >= scrollHeight) {
                incrementOwners();
            }
        }
    };

    const incrementOwners = () => {
        if (!!fetchNextPage) {
            // setFetchNextPage(vendors.pageNumber * vendors.pageSize < vendors.totalRecords);
            let newSearchOptions = _.cloneDeep(ownerSearchDataOptions);
            newSearchOptions.incrementPageNumber();
            setOwnerSearchDataOptions(newSearchOptions);
        }
    };

    const setOwnerSearchOptions = (searchText: string, ownerType: string) => {
        if (!!ownerSearchDataOptions) {
            const tableConfig: ITableConfig = {
                rowCount: 25,
                idField: 'Id',
                pageNumber: 1,
                columns: []
            };
            let newSearchDataOptions = ODataOptions.from(tableConfig);
            if (searchText?.length > 0) {
                newSearchDataOptions.addFilter(new ODataFilter('omni', ODataFilterOperators.Contains, searchText));
                newSearchDataOptions.addFilter(new ODataFilter('type', ODataFilterOperators.Contains, ownerType));
            }
            setOwnerSearchDataOptions(newSearchDataOptions);
        }
    };

    const searchPagedOwners = async () => {
        const result = await get(
            `v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/owner-search${ownerSearchDataOptions.toString()}`
        );

        if (response.ok) {
            if (ownerSearchDataOptions.getPageNumber() > 1) {
                let tempResult = _.cloneDeep(searchResults);
                tempResult.items = [...tempResult.items].concat([...result.items]);
                setSearchResults(tempResult);
            } else {
                setSearchResults(result);
            }
            setFetchNextPage(result.pageNumber * result.pageSize < result.totalRecords);
        } else {
            console.log('Unable to get owner data!!!');
        }
    };

    const getTractsByOwnerId = async (ownerId: number) => {
        const result = await get(
            `v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leasegeneration/owner/${ownerId}`
        );

        if (response.ok) {
            setOwnerTracts(result.tracts);
        }
    };

    const getOwnerDetail = async (ownerLookupId: number, containerId: number, type: string) => {
        const result = await get(`v1.0/projects/${appContext.projectNumber}/owners/${ownerLookupId}/${containerId}/${type}`);

        if (response.ok) {
            setOwnerDetails(result);
        }
    };

    // TODO: Refactor validation to work with React-hook forms.
    const validate = (values: AnyObject) => {
        values.ownerType = parseInt(values.ownerType, 10);
        const errors: AnyObject = {};
        if (page === AddOwnershipPages.NewOwnerDecimalInterest || page === AddOwnershipPages.DeviationDecimalInterest) {
            if (!_.get(values, 'ownership.decimalInterest')) {
                _.set(errors, 'ownership.decimalInterest', 'Required');
            }
            if (values.ownerType === OwnerType.Individual) {
                if (!_.get(values, 'ownership.isCommunityProperty')) {
                    _.set(errors, 'ownership.isCommunityProperty', 'Required');
                }
            }
            if (
                props.dialogType === 'ADD_ADDITIONAL_OWNERSHIP' &&
                props.parentOwnershipId > 0 &&
                !_.get(values, 'ownership.additionalOwnershipTypeId')
            ) {
                _.set(errors, 'ownership.additionalOwnershipTypeId', 'Required');
            }
        }
        if (page === AddOwnershipPages.NewOwnerInfoForm || page === AddOwnershipPages.NewDeviationInfoForm) {
            if (values.ownerType === OwnerType.Individual) {
                if (!_.get(values, 'individualOwner.firstName')) {
                    _.set(errors, 'individualOwner.firstName', 'Required');
                }
                if (!_.get(values, 'individualOwner.lastName')) {
                    _.set(errors, 'individualOwner.lastName', 'Required');
                }
            } else if (values.ownerType === OwnerType.Trust) {
                if (!_.get(values, 'ownerTrust.trustName')) {
                    _.set(errors, 'ownerTrust.trustName', 'Required');
                }
                if (!_.get(values, 'ownerTrust.contactPersonFirstName')) {
                    _.set(errors, 'ownerTrust.contactPersonFirstName', 'Required');
                }
                if (!_.get(values, 'ownerTrust.contactPersonLastName')) {
                    _.set(errors, 'ownerTrust.contactPersonLastName', 'Required');
                }
            } else if (values.ownerType === OwnerType.Business) {
                if (!_.get(values, 'businessOwner.name')) {
                    _.set(errors, 'businessOwner.name', 'Required');
                }
                if (!_.get(values, 'businessOwner.contactPersonFirstName')) {
                    _.set(errors, 'businessOwner.contactPersonFirstName', 'Required');
                }
                if (!_.get(values, 'businessOwner.contactPersonLastName')) {
                    _.set(errors, 'businessOwner.contactPersonLastName', 'Required');
                }
            } else if (values.ownerType === OwnerType.GovBLM) {
                if (!_.get(values, 'bolmOwner.regionalOffice')) {
                    _.set(errors, 'bolmOwner.regionalOffice', 'Required');
                }
                if (!_.get(values, 'bolmOwner.contactPersonFirstName')) {
                    _.set(errors, 'bolmOwner.contactPersonFirstName', 'Required');
                }
            } else if (values.ownerType === OwnerType.GovRAL) {
                if (!_.get(values, 'ralOwner.surfaceOwnerAgentFirstName')) {
                    _.set(errors, 'ralOwner.surfaceOwnerAgentFirstName', 'Required');
                }
                if (!_.get(values, 'ralOwner.surfaceOwnerAgentLastName')) {
                    _.set(errors, 'ralOwner.surfaceOwnerAgentLastName', 'Required');
                }
            } else if (values.ownerType === OwnerType.GovSTATE) {
                if (!_.get(values, 'stateLandOwner.agencyName')) {
                    _.set(errors, 'stateLandOwner.agencyName', 'Required');
                }
                if (!_.get(values, 'stateLandOwner.contactPersonFirstName')) {
                    _.set(errors, 'stateLandOwner.contactPersonFirstName', 'Required');
                }
                if (!_.get(values, 'stateLandOwner.contactPersonLastName')) {
                    _.set(errors, 'stateLandOwner.contactPersonLastName', 'Required');
                }
            } else if (values.ownerType === OwnerType.JointTenant) {
                // ownerJointTenant.name
                if (!_.get(values, 'ownerJointTenant.name')) {
                    _.set(errors, 'ownerJointTenant.name ', 'Required');
                }
            }
        }
        return errors as FormErrors<AnyObject>;
    };

    const submitOwnership = (formValues: AnyObject) => {
        if (props.dialogType === 'ADD_OWNERSHIP' || props.dialogType === 'ADD_ADDITIONAL_OWNERSHIP') {
            const values = cleanValues(formValues) as AddOwnershipData;
            props.saveAddTractOwnership(values);
        } else if (props.dialogType === 'ADD_WI_OWNERSHIP' || props.dialogType === 'ADD_ORRI_OWNERSHIP') {
            const values = cleanValues(formValues) as AddWIOwnershipData;
            props.saveAddLeaseOwnership(values);
        }

        initializeFormAndState();
        setOwnerTracts(undefined);
        setSearchResults(undefined);
        props.onCloseDialog();
    };

    const cleanValues = (values: AnyObject) => {
        console.log('clean values', values);
        if (values.ownerType) {
            values.ownerType = parseInt(values.ownerType + '', 10);
        }
        if (values.ownership && values.ownership.decimalInterest) {
            values.ownership.decimalInterest = parseFloat(values.ownership.decimalInterest + '');
        }
        if (values.ownership && values.ownership.isCommunityProperty) {
            values.ownership.isCommunityProperty = values.ownership.isCommunityProperty === 'Yes' ? false : true;
        }
        return values;
    };

    return (
        <Dialog title={props.title}>
            <div style={{ width: '100rem' }}>
                <NewOwnerForm
                    validate={validate}
                    submitOwnership={submitOwnership}
                    dialogType={props.dialogType}
                    getCityState={getCityState}
                    horizon={props.horizon}
                    ownerTypes={ownerTypes}
                    ownershipType={ownershipType}
                    page={page}
                    phoneNumberTypes={phoneNumberTypes}
                    searchResults={searchResults}
                    states={states}
                    tract={props.tract}
                    turnPage={(addOwnershipPage) => setPage(addOwnershipPage)}
                    parentOwnershipId={props.parentOwnershipId}
                    initializeFormAndState={initializeFormAndState}
                    isLeasehold={true}
                />
                <ExistingOwnerForm
                    clientNumber={appContext.clientNumber}
                    projectNumber={appContext.projectNumber}
                    getCityState={getCityState}
                    getTractsByOwnerId={getTractsByOwnerId}
                    horizon={props.horizon}
                    ownerDetails={ownerDetails}
                    ownerTracts={ownerTracts}
                    ownerTypes={ownerTypes}
                    page={page}
                    phoneNumberTypes={phoneNumberTypes}
                    submitOwnership={submitOwnership}
                    validate={validate}
                    searchOwners={setOwnerSearchOptions}
                    searchResults={searchResults}
                    states={states}
                    tract={props.tract}
                    turnPage={(addOwnershipPage) => setPage(addOwnershipPage)}
                    addDeviation={props.addDeviation}
                    getOwnerDetail={getOwnerDetail}
                    parentOwnershipId={props.parentOwnershipId}
                    dialogType={props.dialogType}
                    isLeasehold={true}
                    getScrollStatus={getScrollStatus}
                />
            </div>
        </Dialog>
    );
};

export default AddMineralOwnership;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/AddOwnership.redesign.tsx